/* eslint-disable no-restricted-syntax */
import { getDefinition, getTypedInheritanceChain } from '../classes/object-definition';
function isPrimitive(type) {
    return type === String || type === Boolean || type === Number;
}
// THIS IS FOR PURELY SERIAL/DESERIAL AND PICKING THE RIGHT TYPE FOR OBJECT, not for validation at all.
// Because this is for serial/deserial, it is very lax on PRIMITIVE types (ie bool/str/number);
// dynamicobject is for serial, jsonvalue for deserial
// luckily this code can use "both"
export function serdeGetType(object, definition) {
    let typeToUse = definition.type;
    const isPrim = isPrimitive(typeToUse) || object === null;
    // at this point the object has been VALIDATED already, so we know the object itself if "valid"
    // IF the object is null, then we just return the value; no need to serialize
    if (definition.compoundType && object !== null) {
        // for compound types, figure out which of the types to actually use
        if (object.constructor === Array) {
            // this was dealt with in seralizeArray, so it shouldn't happen here
            // don't throw an error, since old behavior was just to continue
            console.warn('serdeGetType: object.constructor === Array, this shouldnt happen');
        }
        else if (typeof object === 'object') {
            // object means it needs to be a complex object that gets serialized properly
            for (const funcType of definition.types) {
                const defForFunc = getDefinition(funcType);
                if (!defForFunc) {
                    // no definition means simple type
                    // ignore simple types - if the value is a simple type it would've not gone in here anyways
                    continue;
                }
                else {
                    // just use the first object that it can validate into
                    if (object.constructor === funcType) {
                        // this is for serialization; we get passed in IDynamicObject, ie a class instance, so just
                        // check the constructor and funcType are the same
                        typeToUse = funcType;
                        break;
                    }
                    if (object.constructor === Object) {
                        // this is for deserialization; we just get passed a JsonValueObject, just some generic object, so try
                        // to validate it against the schema
                        try {
                            // TODO YI: remove once we start throwing deser errors for discrim WP-23788
                            const typeChain = getTypedInheritanceChain(funcType);
                            if (defForFunc.discriminatorValue) {
                                let discrimProp;
                                // check it's the correct discriminator value
                                // get the discrimProp
                                if (!discrimProp) {
                                    for (const t of typeChain) {
                                        const d = getDefinition(t);
                                        if (d?.discriminatorProperty) {
                                            discrimProp = d.discriminatorProperty;
                                            break;
                                        }
                                    }
                                }
                                // possible you have random objects in schema, like ObjectA | InheritedFromObjB | InheritedFromObjC
                                // so the discrimProp might not exist
                                if (discrimProp && discrimProp in object) {
                                    // check discrim value matches
                                    if (object[discrimProp] !== defForFunc.discriminatorValue)
                                        continue;
                                }
                            }
                            // gotta validate entire chain, since the child object's schema does not have parent's required fields
                            for (const t of typeChain) {
                                getDefinition(t).validate(object);
                            }
                            typeToUse = funcType;
                            break;
                        }
                        catch (e) {
                            continue;
                        }
                    }
                }
            }
        }
        else {
            // so for primitive types, we just return the value, but try to return the right type anyways
            for (const funcType of definition.types) {
                if (isPrimitive(funcType)) {
                    if (funcType === String && typeof object === 'string') {
                        typeToUse = funcType;
                        break;
                    }
                    else if (funcType === Number && typeof object === 'number') {
                        typeToUse = funcType;
                        break;
                    }
                    else if (funcType === Boolean && typeof object === 'boolean') {
                        typeToUse = funcType;
                        break;
                    }
                }
            }
        }
    }
    return { typeToUse, isPrimitive: isPrim };
}
//# sourceMappingURL=compound-serde.js.map